
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters('sideDrawer', ['sideDrawerType']),
    },
    methods: {},
};
